import axios from "utils/axios";
import { GET_SUPPLIER_TRUSTED_COMPANIES_URL } from "config/services";

export const getSupplierRecommendationInsights = async ({ entityId, supplierIds, source = "MARKETPLACE", vendors, signal }) => {
  // Optional history failures must not trigger the app's sign-out interceptor.
  const client = axios.create(axios.defaults);
  const response = await client.post(`${GET_SUPPLIER_TRUSTED_COMPANIES_URL}/recommendation-insights`, {
    entityId,
    ...(source === "INTERNAL" ? { source, vendors } : { supplierIds }),
  }, { signal, timeout: 15000 });
  const payload = response.data?.payload;
  if (response.data?.error || !Array.isArray(payload?.items) || typeof payload.canViewTrustedCompanies !== "boolean") {
    throw new Error("Supplier history is temporarily unavailable.");
  }
  return payload;
};
